// x-release-please-start-version
export const version = '0.6.2'
// x-release-please-end
